<!----小票预览列表------>
<template>
  <div class="list-bill-view">
    <div v-if="list.length===0" class="empty-data">暂无数据</div>
    <div v-else>
      <div v-if="title">
        <p>
          <span>{{title.orderType.label}}：</span>
          <span>{{title.orderType.prop}}</span>
        </p>
        <p>
          <span>{{title.orderNo.label}}：</span>
          <span>{{title.orderNo.prop}}</span>
        </p>
        <p>
          <span>{{title.lastModifyDttm.label}}：</span>
          <span>{{title.lastModifyDttm.prop}}</span>
        </p>
        <p>
          <span>{{title.mbMemberId.label}}：</span>
          <span>{{title.mbMemberId.prop}}</span>
        </p>
        <p>
          <span>{{title.cashierName.label}}：</span>
          <span>{{title.cashierName.prop}}</span>
        </p>
      </div>
      <table class="table-info">
        <thead>
        <tr>
          <td v-for="(column,index) in columns"
              :key="index"
              :width="column.width">{{column.label}}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(line,index) in tableData" :key="index">
          <td v-for="(item,lineIndex) in line.item" :key="lineIndex">
            <span>{{item.value}}</span>
            <span v-if="item.name == 'goodsName' && item.child.unitPrice == 0">(赠送)</span>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="price-info" v-if="foot">
        <div class="flex-between" v-if="foot.allPrice">
          <span>{{foot.allPrice.label}}：</span>
          <span>{{foot.allPrice.prop}}</span>
        </div>
        <div class="flex-between" v-if="foot.discountPrice">
          <span>{{foot.discountPrice.label}}：</span>
          <span>{{foot.discountPrice.prop}}</span>
        </div>
        <div class="flex-between" v-if="foot.amountReceived">
          <span>{{foot.amountReceived.label}}：</span>
          <span>{{foot.amountReceived.prop}}</span>
        </div>
        <div class="flex-between" v-if="foot.payType">
          <span>{{foot.payType.label}}：</span>
          <span>{{foot.payType.prop}}</span>
        </div>
        <div class="flex-between" v-if="foot.boxPrice">
          <span>{{foot.boxPrice.label}}：</span>
          <span>{{foot.boxPrice.prop}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    columns:{
      type: Array,
      default: ()=>[],
    },
    list:{
      type: Array,
      default: ()=>[],
    },
    title:{
      type: Object,
      default: () => {
        return {}
      },
    },
    foot:{
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  data() {
    return {
      tableRow: {},
    };
  },
  mounted() {
  },
  computed:{
    tableData(){
      const arr= []
      this.list.forEach(v=>{
        const line = {item:[]}
        this.columns.forEach(i=>{
          line.item.push({
            name:i.prop,
            value:v[i.prop],
            child:v
          })
        })
        arr.push(line)
      })
      return arr
    }
  },
  methods: {
  },
};
</script>
<style>
.list-bill-view{
  padding:0 20px 20px 20px;
}
.list-bill-view .empty-data{
  text-align: center;
  color:#ccc;
}
.list-bill-view p{
  line-height: 30px;
}
.list-bill-view .el-table {
  border: 1px solid #ccc;
}
.list-bill-view .el-table__footer-wrapper tbody td,
.list-bill-view .el-table__header-wrapper tbody td {
  background-color: transparent;
}
.list-bill-view .el-table th,
.list-bill-view .el-table tr {
  line-height: 37px;
}
/*dialog头部标题和关闭对齐*/
.el-dialog__headerbtn{
  top:10px !important;
}
.list-bill-view .price-info{
  border-bottom:1px dashed #999;
}
.list-bill-view .flex-between{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  font-weight: 700;
}
.list-bill-view .table-info{
  width:100%;
  border-bottom:1px dashed #999;
}
.list-bill-view .table-info thead{
  border-top:1px dashed #999;
  border-bottom:1px dashed #999;
}
.list-bill-view .table-info tr{
  height:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/template/listBillView.vue